
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ChecklistIconComponent } from "./checklist-icon.svg";

export const ChecklistIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ChecklistIconComponent {...props} />;
};
